'use client';
import { Paper } from '@mui/material';

import { mergeSx } from '@abg/kit-base';

import { getBundleAttributes } from '../utils';

import { containerStyling } from './AncillariesBundle.styling';
import { AncillariesBundleBody } from './AncillariesBundleBody';
import { AncillariesBundleHeader } from './AncillariesBundleHeader';
import { AncillariesBundleProps } from './types';

// used for both protections and add-ons pages
export const AncillariesBundle = ({
  styleParts = {},
  bundle,
  selected,
  disabled = false,
  included = false,
  onSelected,
  selectionMode,
}: AncillariesBundleProps) => {
  const {
    code,
    image,
    title,
    description,
    coverageRating,
    items,
    price,
    oldPrice,
    bookAgain,
    recommended,
    currencyCode,
  } = bundle;

  const hasExcessWithPrice =
    code !== 'CP1' &&
    items?.some(
      (item) =>
        (item.code === 'CDW' || item.code === 'ALI') &&
        item.price != null &&
        Number.parseFloat(item.price) > 0,
    );

  const mergedBundleStyling = mergeSx(containerStyling, styleParts.bundle);
  const mergedBundleState = mergeSx(
    disabled ? styleParts.bundleDisabled : {},
    included ? styleParts.bundleIncluded : {},
  );

  return (
    <Paper
      className={`${selected ? 'ancillaries-bundle--selected' : ''}`}
      elevation={3}
      sx={mergeSx(mergedBundleStyling, mergedBundleState)}
      data-testid="ancillaries-bundle"
      {...getBundleAttributes(bundle)}
      onClick={onSelected}
    >
      <AncillariesBundleHeader
        styleParts={styleParts}
        image={image}
        code={code}
        title={title}
        description={hasExcessWithPrice ? '' : description}
        rating={coverageRating}
        recommended={recommended}
        bookAgain={bookAgain}
        disabled={disabled}
        included={included}
        selected={selected}
        selectionMode={selectionMode}
      />
      <AncillariesBundleBody
        styleParts={styleParts}
        items={items ?? []}
        oldPrice={oldPrice}
        price={price}
        bookAgain={bookAgain}
        recommended={recommended}
        currencyCode={currencyCode}
        disabled={disabled}
        included={included}
      />
    </Paper>
  );
};
